const {
	ROLE_EXTERNAL_ADMIN,
	ROLE_COMPETITION_MANAGER,
	ROLE_FIELD_MANAGER,
	ROLE_TIMER_MANAGER,
} = require('shared/constant/lookup/role')

const getApiRolePath = (role) => {
	if (role === ROLE_EXTERNAL_ADMIN) return `external-admin`
	if (
		role === ROLE_COMPETITION_MANAGER ||
		role === ROLE_FIELD_MANAGER ||
		role === ROLE_TIMER_MANAGER
	)
		return `competition-manager`
	return `admin`
}

export default getApiRolePath
